import Input from 'components/common/form/input/Input';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';

function JobPostApplicationForm() {
  return (
    <Row className="g-5">
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="deadline">Application Deadline</FormLabel>
          <Input name="deadline" id="deadline" type="date" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="linkOrEmail">Application Link or Email</FormLabel>
          <Input name="linkOrEmail" id="linkOrEmail" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="numberOfOpenings">Number Of Openings</FormLabel>
          <Input name="numberOfOpenings" id="numberOfOpenings" />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default JobPostApplicationForm;
